import { useState } from 'react';
import * as S from './style';
//hooks
import { useMultipleModal } from '../../../hooks/useMultipleModal';
//icons
import { CalendarDots, CaretDown, Check } from '@phosphor-icons/react';

interface ICalendar {
    setDate: (data: Date) => void;
    oldestYear: number;
}

export default function Calendar({ setDate, oldestYear }: ICalendar) {
    const { assignRef, isOpenModal, toggleModalVisibility } = useMultipleModal();
    // Obter mês e ano atual
    const [currentDate, setCurrentDate] = useState(new Date());
    const [indexDate, setIndexDate] = useState({
        index_month: new Date().getMonth(),
        index_year: new Date().getFullYear(),
    })
    // Lista de meses em português
    const months = [
        'Jan.', 'Fev.', 'Mar.', 'Abr.', 'Mai.', 'Jun.',
        'Jul.', 'Ago.', 'Set.', 'Out.', 'Nov.', 'Dez.'
    ];

    // Formato para exibição
    let formattedDate = `${months[currentDate.getMonth()]}, ${currentDate.getFullYear()}`;
    // Função para gerar lista de anos (5 anos atrás)
    const generateYears = () => {
        const currentYear = new Date().getFullYear();
        const yearOld = currentYear - oldestYear;
        const years = [];
        for (let i = currentYear - yearOld; i <= currentYear; i++) {
            years.push(i);
        }
        return years;
    };

    // Atualizar mês e ano selecionados
    const handleDate = (type: string) => {
        const newDate = new Date(currentDate);
        if (type === 'submit') {
            newDate.setMonth(indexDate.index_month);
            newDate.setFullYear(indexDate.index_year);
        } else if (type === 'clear') {
            newDate.setMonth(new Date().getMonth());
            newDate.setFullYear(new Date().getFullYear());
            setIndexDate(prev => ({
                ...prev,
                index_month: new Date().getMonth(),
                index_year: new Date().getFullYear()
            }))
        }
        setCurrentDate(newDate);
        setDate(newDate);
        toggleModalVisibility('selected-date');
    };

    return (
        <S.Container>
            <S.Button
                isPrimary={false}
                onClick={() => toggleModalVisibility('selected-date')}
            >
                <CalendarDots size={24} />
                <S.H6>{formattedDate}</S.H6>
                <CaretDown size={24} />
            </S.Button>

            {
                isOpenModal('selected-date') && (
                    <S.FilterModal
                        ref={(ref) => assignRef("selected-date", ref)}
                    >
                        <S.Label>Mês</S.Label>
                        <S.ContentFilter>
                            {months.map((month, index) => (
                                <S.ButtonFilter
                                    key={month}
                                    className={`${indexDate.index_month === index ? 'active' : ''}`}
                                    onClick={() => setIndexDate(prev => ({
                                        ...prev,
                                        index_month: index
                                    }))}
                                >
                                    <span>{month}</span>
                                    {indexDate.index_month === index && (
                                        <Check />
                                    )}
                                </S.ButtonFilter>
                            ))}
                        </S.ContentFilter>
                        <S.Label>Ano</S.Label>
                        <S.ContentFilter>
                            {generateYears().map(year => (
                                <S.ButtonFilter
                                    key={year}
                                    className={`${indexDate.index_year === year ? 'active' : ''}`}
                                    onClick={() => setIndexDate(prev => ({
                                        ...prev,
                                        index_year: year
                                    }))}
                                >
                                    <span>{year}</span>
                                    {indexDate.index_year === year && (
                                        <Check />
                                    )}
                                </S.ButtonFilter>
                            ))}
                        </S.ContentFilter>
                        <S.Footer>
                            <S.Button
                                isPrimary={false}
                                onClick={() => handleDate('clear')}>
                                Limpar
                            </S.Button>
                            <S.Button
                                isPrimary={true}
                                onClick={() => handleDate('submit')}>
                                Confirmar
                            </S.Button>
                        </S.Footer>
                    </S.FilterModal>
                )
            }
        </S.Container>
    )
}